export enum SignUpPremSteps {
  CONTACT_INFO,
  COMPLETE,
}
